import Button from '../../common/buttons/Button';

type Props = {
    text: string;
    onClick: () => void;
};

export default function MContinueButton({ text, onClick }: Props) {
    return (
        <div className="m-continue-button-wrapper">
            <Button onClick={onClick} className="secondary-button">
                {text}
            </Button>
        </div>
    );
}
